var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcComillas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.896 16.448L0 15.232C1.32267 14.2507 2.34667 13.0987 3.072 11.776C3.79733 10.4107 4.16 8.93867 4.16 7.36H4.032C3.008 7.36 2.13333 7.01867 1.408 6.336C0.725333 5.61067 0.384 4.736 0.384 3.712C0.384 2.73066 0.725333 1.87733 1.408 1.152C2.13333 0.384 3.008 0 4.032 0C5.09867 0 5.952 0.362666 6.592 1.088C7.27467 1.77067 7.68 2.688 7.808 3.84C7.89333 5.12 7.72267 6.54933 7.296 8.128C6.912 9.70667 6.18667 11.2427 5.12 12.736C4.096 14.2293 2.688 15.4667 0.896 16.448ZM11.904 16.448L11.008 15.232C12.3307 14.2507 13.3547 13.0987 14.08 11.776C14.8053 10.4107 15.168 8.93867 15.168 7.36H15.04C14.016 7.36 13.1413 7.01867 12.416 6.336C11.7333 5.61067 11.392 4.736 11.392 3.712C11.392 2.73066 11.7333 1.87733 12.416 1.152C13.1413 0.384 14.016 0 15.04 0C16.1067 0 16.96 0.362666 17.6 1.088C18.2827 1.77067 18.688 2.688 18.816 3.84C18.9013 5.12 18.7307 6.54933 18.304 8.128C17.92 9.70667 17.1947 11.2427 16.128 12.736C15.104 14.2293 13.696 15.4667 11.904 16.448Z",
    fill: "#0DA0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComillas);
export default __webpack_public_path__ + "static/media/ic_comillas.c2e5b1c1211a854115672ac4420e20d9.svg";
export { ForwardRef as ReactComponent };